<template>
    <div class="province-city-area">
        <div>
            <el-select v-model="pca.province" filterable remote reserve-keyword placeholder="省" :size="size" clearable
                :remote-method="searchRemoteCfcategory" :loading="searchLoading" @change="handleSearchCfcategory">
                <el-option v-for="searchCompany in searchCategories" :key="searchCompany.id" :label="searchCompany.name"
                    :value="searchCompany.code">
                </el-option>
            </el-select>
            -
            <el-select v-model="pca.city" filterable reserve-keyword placeholder="市" :size="size" clearable
                :loading="searchLoading" @change="handleSearchCityChange">
                <el-option v-for="searchCompany in cityOptions" :key="searchCompany.id" :label="searchCompany.name"
                    :value="searchCompany.code">
                </el-option>
            </el-select>
            -
            <el-select v-model="pca.area" filterable reserve-keyword placeholder="区" :size="size" clearable
                :loading="searchLoading" @change="handleSearchAreaChange">
                <el-option v-for="searchCompany in areaOptions" :key="searchCompany.id" :label="searchCompany.name"
                    :value="searchCompany.code">
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProvinceCityArea',
    props: {
        size: {
            type: String,
            default: 'mini'
        },
    },
    data() {
        return {
            pca: {
                province: '',
                city: '',
                area: ''
            },
            searchLoading: false,
            searchCategories: [],
            cityOptions: [],
            areaOptions: []
        }
    },
    methods: {
        searchRemoteCfcategory(query) {
            if (query !== '') {
                this.searchLoading = true
                setTimeout(() => {
                    this.searchLoading = false
                    this.searchItem(query)
                }, 200)
            } else {
                this.searchCategories = []
            }
        },
        searchItem(query) {
            this.$axios
                .get('/api/api3_common_get_province', {
                    params: {
                        search: query,
                    },
                })
                .then(({ data }) => {
                    if (data.code === 0) {
                        this.searchCategories = data.data
                    }
                })
                .catch()
        },
        handleSearchCfcategory(query) {
            this.$emit('provinceCityAreaChange', { k: 'in_province', v: query })
            this.loadCity(query)
        },
        loadCity(provinceCode) {
            this.$axios.get('/api/api3_common_get_city', {
                params: {
                    provinceCode
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.cityOptions = data.data
                }
            }).catch()
        },
        handleSearchCityChange(query) {
            this.$emit('provinceCityAreaChange', { k: 'in_city', v: query })
            this.loadArea(query)
        },
        handleSearchAreaChange(query) {
            this.$emit('provinceCityAreaChange',{k: 'in_area',v: query})
            // this.loadCity()
        },
        loadArea(cityCode) {
            this.$axios.get('/api/api3_common_get_area', {
                params: {
                    cityCode
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.areaOptions = data.data
                }
            }).catch()
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/commonReform/ProvinceCityArea.vue